import Vue from 'vue'
import {Settings} from "luxon";
// import App from './App.vue'
//
// Vue.config.productionTip = false
//
// new Vue({
//   render: h => h(App),
// }).$mount('#app')

import ClickOutside from "vue-click-outside"

import BarChart from "./components/bar-chart"
import Barometer from "./components/barometer"
import FormattedDate from "./components/formatted-date"
import GlobalErrors from "./components/global-errors"
import HashModal from "./components/hash-modal";
import InputCallingCodeAndPhone from "./components/input-calling-code-and-phone"
import InputCustom from "./components/input-custom"
import InputDate from "./components/input-date"
import InputNumber from "./components/input-number"
// import InputPhone from "./components/input-phone"
import InputSecret from "./components/input-secret"
import InputTags from "./components/input-tags"
import InputText from "./components/input-text"
import InputTextarea from "./components/input-textarea"
import LanguageTabs from "./components/language-tabs"
import LocalErrors from "./components/local-errors"
import Modal from "./components/modal"
import SelectBooleanCheckbox from "./components/select-boolean-checkbox"
import SelectManyCheckbox from "./components/select-many-checkbox"
import SelectOneMenu from "./components/select-one-menu"
import SelectOneRadio from "./components/select-one-radio"
import Tree from "./components/tree"
import BBUtil from "./plugins/bb-util"
import Bundle from "./plugins/bundle"
import CvrRestApi from "./plugins/cvr-rest-api"
import DateTimePlugin from "./plugins/date-time-plugin"
import DatetimeUtil from "./plugins/datetime-util"
import FormErrors from "./plugins/form-errors"
import HashUtil from "./plugins/hash-util";
import ParseBoolean from "./plugins/parse-boolean"
import SlugUtil from "./plugins/slug-util"
import Util from "./plugins/util"

Settings.defaultZone = "Europe/Copenhagen";

Vue.use(ParseBoolean);
Vue.mixin({
    computed: {
        console: function () {
            return console
        },
        document: function () {
            return document
        },
        window: function () {
            return window
        }
    },
    directives: {
        ClickOutside
    }
})

export {
    BarChart,
    Barometer,
    FormattedDate,
    GlobalErrors,
    HashModal,
    InputCallingCodeAndPhone,
    InputCustom,
    InputDate,
    InputNumber,
    // InputPhone,
    InputSecret,
    InputTags,
    InputText,
    InputTextarea,
    LanguageTabs,
    LocalErrors,
    Modal,
    SelectBooleanCheckbox,
    SelectManyCheckbox,
    SelectOneMenu,
    SelectOneRadio,
    Tree,
    BBUtil,
    Bundle,
    CvrRestApi,
    DateTimePlugin,
    DatetimeUtil,
    FormErrors,
    HashUtil,
    ParseBoolean,
    SlugUtil,
    Util
}
